<aside
    class="sm:sticky sm:top-0 sm:h-[calc(100vh-68px)] h-screen fixed left-0 bg-white border-r border-[#E7EAF0] z-40 sm:w-[255px] w-full transform transition-transform duration-300 ease-in-out"
    [class.-translate-x-full]="!isOpen && isMobile"
    [class.translate-x-0]="isOpen || !isMobile">
    <!-- Close button (mobile only) -->
    <button type="button" class="absolute top-4 right-4 sm:hidden text-gray-600" (click)="toggleSidebar()">✕</button>

    <div class="flex flex-col justify-between h-full">
        <div class="sm:p-4 p-8">
            <div class="space-y-3">
                @if (showCreatePost()) {
                    <button
                        type="button"
                        class="w-full border-button justify-start py-4 text-sm font-medium"
                        (click)="openCreatePostPopup()">
                        <img src="/assets/images/shared/plus.svg" alt="Plus" class="h-5 w-5 mr-2" />
                        <p>New Post</p>
                    </button>
                }

                <button
                    type="button"
                    class="w-full white-border-button hover:bg-[#F1F5F9] hover:shadow-none rounded-full border-none justify-start py-3 text-sm font-medium"
                    routerLinkActive="active-link"
                    [routerLink]="['/community']"
                    (click)="toggleSidebar()">
                    <img
                        alt="Community"
                        class="h-5 w-5 mr-2"
                        [src]="
                            isActive('/community')
                                ? '/assets/images/sidebar/community-blue-icon.svg'
                                : '/assets/images/sidebar/community-icon.svg'
                        " />
                    <p [class.text-[#4F66FF]]="isActive('/community')">Community</p>
                </button>

                <button
                    type="button"
                    class="w-full white-border-button hover:bg-[#F1F5F9] hover:shadow-none rounded-full border-none justify-start py-3 text-sm font-medium"
                    routerLinkActive="active-link"
                    [routerLink]="['/groups']"
                    (click)="toggleSidebar()">
                    <img
                        alt="Groups"
                        class="h-5 w-5 mr-2"
                        [src]="
                            isActive('/groups')
                                ? '/assets/images/sidebar/groups-blue-icon.svg'
                                : '/assets/images/sidebar/groups-icon.svg'
                        " />
                    <p [class.text-[#4F66FF]]="isActive('/groups')">Groups</p>
                </button>

                <button
                    type="button"
                    class="w-full white-border-button hover:bg-[#F1F5F9] hover:shadow-none rounded-full border-none justify-start py-3 text-sm font-medium"
                    routerLinkActive="active-link"
                    [routerLink]="['/profile/posts']"
                    (click)="toggleSidebar()">
                    <img
                        alt="Profile"
                        class="h-5 w-5 mr-2"
                        [src]="
                            isActive('/profile/posts')
                                ? '/assets/images/sidebar/profile-blue-icon.svg'
                                : '/assets/images/sidebar/profile-icon.svg'
                        " />
                    <p [class.text-[#4F66FF]]="isActive('/profile/posts')">Profile</p>
                </button>
            </div>
        </div>
        <div class="sm:p-6 p-8">
            <p class="text-[#717182] text-xs text-right">
                {{ envName !== 'PRODUCTION' ? APP_VERSION : APP_PROD_VERSION }}
            </p>
        </div>
    </div>
</aside>

<div class="nav-bottom">
    <div class="nav-container">
        <button type="button" [routerLink]="['/community']">
            <img
                alt="Community"
                class="nav-img"
                [src]="
                    isActive('/community')
                        ? '/assets/images/sidebar/community-blue-icon.svg'
                        : '/assets/images/sidebar/community-icon.svg'
                " />
            <p class="text-xs" [class.text-[#4F66FF]]="isActive('/community')">Community</p>
        </button>

        <button type="button" [routerLink]="['/groups']">
            <img
                alt="Groups"
                class="nav-img"
                [src]="
                    isActive('/groups')
                        ? '/assets/images/sidebar/groups-blue-icon.svg'
                        : '/assets/images/sidebar/groups-icon.svg'
                " />
            <p class="text-xs" [class.text-[#4F66FF]]="isActive('/groups')">Groups</p>
        </button>

        <!-- Center FAB -->
        <button type="button" class="fab" (click)="openCreatePostPopup()">
            <img src="/assets/images/shared/plus.svg" alt="Plus" class="size-6" />
        </button>

        <button type="button" [routerLink]="['/notification']">
            <img
                alt="notification"
                class="nav-img"
                [src]="
                    isActive('/notification')
                        ? '/assets/images/shared/notification-icon.svg'
                        : '/assets/images/shared/notification-black-icon.svg'
                " />
            <p class="text-xs" [class.text-[#4F66FF]]="isActive('/notification')">Notification</p>
        </button>

        <button type="button" [routerLink]="['/profile']">
            <img
                alt="Profile"
                class="nav-img"
                [src]="
                    isActive('/profile/posts')
                        ? '/assets/images/shared/profile-blue-nav-icon.svg'
                        : '/assets/images/shared/profile-icon.svg'
                " />
            <p class="text-xs" [class.text-[#4F66FF]]="isActive('/profile/posts')">Profile</p>
        </button>
    </div>
</div>
